import type { ComponentChildren } from 'preact';
import { useLayoutEffect, useRef } from 'preact/hooks';

interface ModalProps {
  labelId: string;
  /** Не задан — окно нельзя закрыть кликом по фону и Escape (например, идёт генерация). */
  onClose?: () => void;
  children: ComponentChildren;
}

export function Modal({ labelId, onClose, children }: ModalProps) {
  const box = useRef<HTMLDivElement>(null);

  // layout-эффект: слушатель Escape должен появиться в тот же тик, что и окно, а не после отрисовки
  useLayoutEffect(() => {
    // Фокус внутрь окна, чтобы клавиатура и скринридер оказались там же, где внимание
    box.current?.querySelector<HTMLElement>('button.primary, button, input, select')?.focus();
    if (!onClose) return;
    const onKey = (e: KeyboardEvent) => e.key === 'Escape' && onClose();
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [onClose]);

  return (
    // biome-ignore lint/a11y/useKeyWithClickEvents: закрытие с клавиатуры — Escape (слушатель на document)
    // biome-ignore lint/a11y/noStaticElementInteractions: клик по фону — удобство для мыши, с клавиатуры окно закрывается по Escape (слушатель на document)
    <div class="overlay on" onClick={(e) => e.target === e.currentTarget && onClose?.()}>
      <div class="modal" role="dialog" aria-modal="true" aria-labelledby={labelId} ref={box}>
        {children}
      </div>
    </div>
  );
}
